














































































































import { ButtonGroup, Icon, Button, Checkbox, Card, Select, SelectOption } from '@alpha/ink'
import { Vue, Component, Prop } from 'vue-property-decorator'
import MultiSelectButtons from '@/components/MultiSelectButtons.vue'
import NoUiSlider from '@/components/NoUISlider.vue'
import HHIBandSelect from './HHIBandSelect.vue'
import { cardDetails, educationLevelOptions, householdTypeOptions, parentalStatusOptions, relationshipStatusOptions, employmentOptions, employeeCountOptions, jobTitleOptions, deviceOptions, bigPurchaseOptions, companyDeptOptions, b2bDecisionOptions, industryOptions, hhiSelectOptions, AudienceCriteriaType, NewAudienceValidationError, NewAudienceValidationErrorType } from './Audience'

type IndustryOption = { name: string }

@Component({
  components: {
    ButtonGroup,
    Icon,
    Button,
    Checkbox,
    Card,
    Select,
    HHIBandSelect,
    NoUiSlider,
    MultiSelectButtons
  }
})

export default class AudienceManagerModalFilterCard extends Vue {
  @Prop({ required: true }) readonly filterName!: AudienceCriteriaType
  @Prop({ required: true }) readonly audienceFilters!: any
  @Prop({ default: null }) readonly validationError!: NewAudienceValidationError | null

  NewAudienceValidationErrorType = NewAudienceValidationErrorType
  educationLevelOptions = educationLevelOptions
  householdTypeOptions = householdTypeOptions
  parentalStatusOptions = parentalStatusOptions
  relationshipStatusOptions = relationshipStatusOptions
  employmentOptions = employmentOptions
  employeeCountOptions = employeeCountOptions
  jobTitleOptions = jobTitleOptions
  deviceOptions = deviceOptions
  bigPurchaseOptions = bigPurchaseOptions
  companyDeptOptions = companyDeptOptions
  b2bDecisionOptions = b2bDecisionOptions
  industryOptions = industryOptions
  cardDetails = cardDetails
  hhiSelectOptions = hhiSelectOptions
  value = ''

  get industryValuesFormatted (): IndustryOption[] {
    return this.audienceFilters.Industry.map((industry: string) => {
      return {
        name: industry
      }
    })
  }

  get validationErrorType (): NewAudienceValidationErrorType | undefined {
    return this.validationError?.type
  }

  get filtersApplied () {
    switch (this.filterName) {
      case AudienceCriteriaType.ADDITIONAL:
        return this.audienceFilters[this.filterName] !== ''
      case AudienceCriteriaType.US_HHI:
        return (this.audienceFilters[this.filterName][0] || this.audienceFilters[this.filterName][1] !== 5000)
      default:
        return this.audienceFilters[this.filterName].length
    }
  }

  get filterWarning () {
    switch (this.filterName) {
      case AudienceCriteriaType.GEOGRAPHIC_LOCATION:
      case AudienceCriteriaType.ADDITIONAL:
      case AudienceCriteriaType.AGE:
        break
      case AudienceCriteriaType.B2B_DECISIONS:
        if (this.audienceFilters[this.filterName].length === this.cardDetails[this.filterName].options?.length) {
          return 'By selecting all filter criteria, your audience will remain unfiltered based on decision making authority.'
        }
        break
      case AudienceCriteriaType.US_HHI:
        if (this.audienceFilters[this.filterName][0] === 0 && this.audienceFilters[this.filterName][1] === Infinity) {
          return `By expanding the range to include all income amounts, your audience will remain unfiltered based on ${this.filterName.toLowerCase()}.`
        }
        break
      default:
        if (this.audienceFilters[this.filterName].length === this.cardDetails[this.filterName].options?.length) {
          return `By selecting all filter criteria, your audience will remain unfiltered based on ${this.filterName.toLowerCase()}.`
        }
        break
    }
  }

  getHHIValueForBand (value: number, band: string) {
    const index = band === 'min' ? 0 : 1
    return this.hhiSelectOptions[index].find(opt => opt.value === value)
  }

  sentenceCase (title: string) {
    const words = title.split(' ')
    if (words.length > 1) {
      const sentenceCase = words.map((word, index) => {
        if (index) {
          return word.toLowerCase()
        } else {
          return word
        }
      })
      return sentenceCase.join(' ')
    } else {
      return words.join(' ')
    }
  }

  removeFilter (filterName: string) {
    if (filterName === 'HHI') {
      this.$emit('setFilterStatus', 'Household Income')
    } else {
      this.$emit('setFilterStatus', filterName)
    }
  }

  setCriteriaValue (criteriaType: string, values: string[] | string | SelectOption, hhiBand: string | null = null) {
    let parsedValues = values
    if (hhiBand) {
      const val = (values as SelectOption).value
      const allowed = hhiBand === 'min' ? !this.audienceFilters['Household Income'][1] ? true : (!!(val !== null && val < this.audienceFilters['Household Income'][1])) : (!!(val !== null && val > this.audienceFilters['Household Income'][0]))
      if (!allowed) {
        // Don't do anything since this value is not allowed
        return
      }
      if (hhiBand === 'min') {
        parsedValues = [(values as SelectOption).value, this.audienceFilters['Household Income'][1]]
      } else if (hhiBand === 'max') {
        parsedValues = [this.audienceFilters['Household Income'][0], (values as SelectOption).value]
      }
    }
    if (criteriaType === 'Industry') {
      parsedValues = (parsedValues as string[]).map((value: string | IndustryOption) => {
        if (typeof value === 'object') {
          return value.name
        } else {
          return value
        }
      })
    }
    this.$emit('updatePrequal', { prequal: criteriaType, values: parsedValues })
  }

  toggleCriteriaValue (criteriaType: AudienceCriteriaType, value: string) {
    const currentValue = this.audienceFilters[criteriaType]
    if (currentValue === undefined) return
    if (currentValue.includes(value)) {
      this.setCriteriaValue(criteriaType, currentValue.filter((v: string) => v !== value))
    } else {
      this.setCriteriaValue(criteriaType, [...currentValue, value])
    }
  }
}
